import { Navigate, Outlet } from 'react-router-dom';

import { Logo } from '@/components/common/logo';
import { useAuth } from '@/features/auth';

import { Footer } from '../components/footer';
import { LanguageSwitcher } from './components/language-switcher';

/**
 * This element renders as react router's Root element.
 * Please follow the below link for more details
 * https://reactrouter.com/en/main/start/tutorial#nested-routes
 */
export const UnprotectedLayout: React.FC = () => {
  const { isLoggedIn, user } = useAuth();

  // if user is already logged in, redirect to relevent dashboard
  if (isLoggedIn) {
    const signedInMethod = user?.signedInMethod;
    return <Navigate to={`/dashboard/${signedInMethod}`} replace />;
  }

  return (
    <div className="flex flex-col justify-between h-screen">
      <header className="sticky top-0 z-40 flex justify-between px-4 pt-4 bg-white md:pt-12 md:container md:mx-auto">
        <Logo />
        <LanguageSwitcher />
      </header>

      <main className="relative px-4 mb-auto md:px-0 md:container md:mx-auto">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};
